import { SET_EXPORT_MAP_MODAL } from '../actions/modals';

const defaultState = {
  showExportMapModal: null,
};

const modalsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_EXPORT_MAP_MODAL:
      return {
        ...state,
        showExportMapModal: action.payload,
      };
    default:
      return state;
  }
};

export default modalsReducer;
